export default {
  ACCOUNT_PURPOSES: 'account-purposes',
  BANKS: 'banks',
  BANK_ACCOUNT_TYPES: 'bank-account-types',
  COUNTRIES: 'countries',
  CITIES: 'cities',
  CIVIL_STATUSES: 'civil-statuses',
  CURRENCIES: 'currencies',
  ECONOMIC_ACTIVITIES: 'economic-activities',
  EXECUTIVES: 'executives',
  INFORMATION_DESTINATIONS: 'information-destinations',
  INSTRUCTION_TYPES: 'instruction-types',
  INVESTOR_PROFILE_QUESTIONS: 'investor-profile-questions',
  INVESTOR_PROFILES: 'investor-profiles',
  INVESTOR_PROFILES_VEHICULES: 'investor-profiles',
  MONTHLY_INCOME_RANGES: 'monthly-income-ranges',
  ORDER_TYPES: 'order-types',
  PARTNER_CLIENT_RELATIONS: 'partner-client-relations',
  PATRIMONIAL_REGIMES: 'patrimonial-regimes',
  PRODUCTS: 'products',
  REGIONS: 'regions',
  SEXES: 'sexes',
  SOCIETY_TYPES: 'society-types',
  VANTRUST_POSITIONS: 'vantrust-positions',
  VANTRUST_RELATIONS: 'vantrust-relations',
  WORKER_TYPES: 'worker-types',
  INVESTOR_VEHICLE_PRODUCTS: 'investor-vehicle-products',
  VEHICLES: 'vehicles',
};
